export const getSatisfactionExplanation = (rating: number) => {
  if (rating > 0.5) return 'Very Satisfied'
  else if (rating >= 0) return 'Satisfied'
  else if (rating >= -0.5) return 'Neutral'
  return 'Dissatisfied'
}
